import { NotificationEnum } from '../../../models/notificationEnum';
import { RecipientEnum } from '../../../models/recipientEnum';
import { TemplateTranslation } from '../../../models/translation';

export const templatesFr: TemplateTranslation = {
  locale: 'fr',
  templates: {
    [NotificationEnum.ACCEPTED_TIME_TRACKING]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Temps de travail approuvé',
          body: {
            introText:
              'Le temps de travail que vous avez saisi pour le service suivant a été approuvé :',
          },
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Temps de travail approuvé',
          body: {
            introText:
              'Le temps de travail saisi pour le service suivant a été approuvé :',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Temps de travail approuvé',
          body: {
            introText:
              'Le temps de travail saisi pour le service suivant a été approuvé :',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Temps de travail approuvé',
          body: {
            introText:
              'Le temps de travail saisi pour le service suivant a été approuvé :',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Temps de travail approuvé',
          body: {
            introText:
              'Le temps de travail saisi pour le service suivant a été approuvé :',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Temps de travail approuvé',
          body: {
            introText:
              'Le temps de travail saisi pour le service suivant a été approuvé :',
          },
        },
      },
      [RecipientEnum.ORGANISATION]: {
        EMAIL: {
          subject: 'IN-POOL - Temps de travail approuvé',
          body: {
            introText:
              'Le temps de travail saisi pour le service suivant a été approuvé :',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Temps de travail approuvé',
          body: {
            introText:
              'Le temps de travail saisi pour le service suivant a été approuvé :',
          },
        },
      },
    },
    [NotificationEnum.ACTION_REQUIRED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Aucun employé affecté au service',
          body: {
            introText:
              "Aucun employé n'a encore été invité pour le service suivant, ou tous les employés invités ont refusé :",
            textBeforeAction:
              "Veuillez inviter d'autres employés si possible :",
            actionButtonText: 'Aller au service',
          },
        },
        PUSH: {
          title: 'IN-POOL - Aucun employé affecté au service',
          body: 'Tous les employés invités ont refusé : {{job.department.displayName}} le {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Aucun employé affecté au service',
          body: {
            introText:
              "Aucun employé n'a encore été invité pour le service suivant, ou tous les employés invités ont refusé :",
            textBeforeAction:
              "Veuillez inviter d'autres employés si possible :",
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Aucun employé affecté au service',
          body: {
            introText:
              "Aucun employé n'a encore été invité pour le service suivant, ou tous les employés invités ont refusé :",
            textBeforeAction:
              "Veuillez inviter d'autres employés si possible :",
            actionButtonText: 'Aller au service',
          },
        },
      },
    },
    [NotificationEnum.ACTION_REQUIRED_ACCEPT_INVITEE]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Nouveau service accepté',
          body: {
            introText: 'Le service suivant a été accepté :',
            textBeforeAction: "Acceptez l'employé souhaité :",
            actionButtonText: 'Aller au service',
          },
        },
        PUSH: {
          title: 'IN-POOL - Nouveau service accepté',
          body: 'Le service suivant a été accepté : {{job.department.displayName}} le {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Nouveau service accepté',
          body: {
            introText: 'Le service suivant a été accepté :',
            textBeforeAction: "Acceptez l'employé souhaité :",
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Nouveau service accepté',
          body: {
            introText: 'Le service suivant a été accepté :',
            textBeforeAction: "Acceptez l'employé souhaité :",
            actionButtonText: 'Aller au service',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_ACTION_REQUIRED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Aucun employé affecté à la mission',
          body: {
            introText:
              "Aucun employé n'a encore été invité pour la mission suivante, ou tous les employés invités ont refusé :",
            textBeforeAction:
              "Veuillez inviter d'autres employés si possible :",
            actionButtonText: 'Aller à la mission',
          },
        },
        PUSH: {
          title: 'IN-POOL - Aucun employé affecté à la mission',
          body: 'Tous les employés invités ont refusé : {{employment.department.displayName}} pour {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Aucun employé affecté à la mission',
          body: {
            introText:
              "Aucun employé n'a encore été invité pour la mission suivante, ou tous les employés invités ont refusé :",
            textBeforeAction:
              "Veuillez inviter d'autres employés si possible :",
            actionButtonText: 'Aller à la mission',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_ACTION_REQUIRED_ACCEPT_INVITEE]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Nouvelle mission acceptée',
          body: {
            introText: 'La mission suivante a été acceptée :',
            textBeforeAction: "Acceptez l'employé souhaité :",
            actionButtonText: 'Aller à la mission',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Nouvelle mission acceptée',
          body: {
            introText: 'La mission suivante a été acceptée :',
            textBeforeAction: "Acceptez l'employé souhaité :",
            actionButtonText: 'Aller à la mission',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Nouvelle mission acceptée',
          body: {
            introText: 'La mission suivante a été acceptée :',
            textBeforeAction: "Acceptez l'employé souhaité :",
            actionButtonText: 'Aller à la mission',
          },
        },
      },
    },
    [NotificationEnum.ADD_TIME_TRACKING]: {
      [RecipientEnum.USER]: {
        SMS: 'Saisie des heures manquante : pour {{departmentName}} \nVers le tableau de bord : {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Saisir les heures de travail',
          body: {
            introText:
              "Les heures de travail n'ont pas encore été saisies pour le service suivant :",
            textBeforeAction: 'Veuillez le faire dès que possible :',
            actionButtonText: 'Aller à la saisie des heures',
          },
        },
        PUSH: {
          title: 'IN-POOL - Saisir les heures de travail',
          body: 'Saisie des heures manquante : {{job.department.displayName}} le {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.EXTERNAL_USER]: {
        EMAIL: {
          subject: 'IN-POOL - Saisir les heures de travail',
          body: {
            introText:
              "Les heures de travail n'ont pas encore été saisies pour le service suivant :",
            textBeforeAction: 'Veuillez utiliser le lien suivant :',
            actionButtonText: 'Aller à la saisie des heures',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_FOR_CREATOR]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Approuver les heures de travail',
          body: {
            introText:
              'Les heures de travail saisies pour le service suivant ont été soumises pour approbation :',
            textBeforeAction:
              'Veuillez vérifier et approuver les heures de travail saisies :',
            actionButtonText: 'Aller à la saisie des heures',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Approuver les heures de travail',
          body: {
            introText:
              'Les heures de travail saisies pour le service suivant ont été soumises pour approbation :',
            textBeforeAction:
              'Veuillez vérifier et approuver les heures de travail saisies :',
            actionButtonText: 'Aller à la saisie des heures',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_FOR_HOSPITAL]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Approuver les heures de travail',
          body: {
            introText:
              'Les heures de travail saisies pour le service suivant ont été soumises pour approbation :',
            textBeforeAction:
              'Veuillez vérifier et approuver les heures de travail saisies :',
            actionButtonText: 'Aller à la saisie des heures',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Approuver les heures de travail',
          body: {
            introText:
              'Les heures de travail saisies pour le service suivant ont été soumises pour approbation :',
            textBeforeAction:
              'Veuillez vérifier et approuver les heures de travail saisies :',
            actionButtonText: 'Aller à la saisie des heures',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_FOR_AGENCY]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Approuver les heures de travail',
          body: {
            introText:
              'Les heures de travail saisies pour le service suivant ont été soumises pour approbation :',
            textBeforeAction:
              'Veuillez vérifier et approuver les heures de travail saisies :',
            actionButtonText: 'Aller à la saisie des heures',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_REMINDER_FOR_CREATOR]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Approuver les heures de travail',
          body: {
            introText:
              "Les heures de travail saisies pour le service suivant n'ont pas encore été approuvées :",
            textBeforeAction: 'Veuillez le faire dès que possible :',
            actionButtonText: 'Aller à la saisie des heures',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Approuver les heures de travail',
          body: {
            introText:
              "Les heures de travail saisies pour le service suivant n'ont pas encore été approuvées :",
            textBeforeAction: 'Veuillez le faire dès que possible :',
            actionButtonText: 'Aller à la saisie des heures',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_REMINDER_FOR_HOSPITAL]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Approuver les heures de travail',
          body: {
            introText:
              "Les heures de travail saisies pour le service suivant n'ont pas encore été approuvées :",
            textBeforeAction: 'Veuillez le faire dès que possible :',
            actionButtonText: 'Aller à la saisie des heures',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Approuver les heures de travail',
          body: {
            introText:
              "Les heures de travail saisies pour le service suivant n'ont pas encore été approuvées :",
            textBeforeAction: 'Veuillez le faire dès que possible :',
            actionButtonText: 'Aller à la saisie des heures',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_REMINDER_FOR_AGENCY]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Approuver les heures de travail',
          body: {
            introText:
              "Les heures de travail saisies pour le service suivant n'ont pas encore été approuvées :",
            textBeforeAction: 'Veuillez le faire dès que possible :',
            actionButtonText: 'Aller à la saisie des heures',
          },
        },
      },
    },
    [NotificationEnum.BOOKED_INTERNAL]: {
      [RecipientEnum.USER]: {
        SMS: 'Vous avez été réservé par {{customerName}} : {{departmentName}} \nVers le tableau de bord : {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Réservé : {{{job.department.displayName}}}',
          body: {
            introText:
              'Vous avez été réservé par {{customerName}} pour le service suivant :',
            outroText: "Vous trouverez en pièce jointe l'entrée du calendrier.",
            actionButtonText: 'Vers le tableau de bord',
          },
        },
        PUSH: {
          title: 'IN-POOL - Réservé : {{job.department.displayName}}',
          body: 'Vous avez été réservé par {{customerName}} : {{job.department.displayName}} le {{job.date}}{{#invitee.partialTimes}} / {{from}} - {{to}} {{/invitee.partialTimes}}{{^invitee.partialTimes}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}{{/invitee.partialTimes}}',
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Réservé {{user.firstName}} {{user.lastName}} le {{job.date}} à {{job.department.displayName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour le service suivant :',
            actionButtonText: 'Aller au service',
          },
        },
        PUSH: {
          title:
            'IN-POOL - Réservé {{user.firstName}} {{user.lastName}} le {{job.date}} à {{job.department.displayName}}',
          body: 'Une personne de {{customerName}} a été réservée pour le service suivant : {{job.department.displayName}} le {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Réservé {{user.firstName}} {{user.lastName}} le {{job.date}} à {{job.department.displayName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour le service suivant :',
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Réservé {{user.firstName}} {{user.lastName}} le {{job.date}} à {{job.department.displayName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour le service suivant :',
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.SHARED_POOL_OWNER]: {
        EMAIL: {
          subject:
            'IN-POOL - Réservé {{user.firstName}} {{user.lastName}} le {{job.date}} à {{job.department.displayName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour le service suivant :',
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Réservé {{user.firstName}} {{user.lastName}} le {{job.date}} à {{job.department.displayName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour le service suivant :',
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Réservé {{user.firstName}} {{user.lastName}} le {{job.date}} à {{job.department.displayName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour le service suivant :',
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.ORGANISATION]: {
        EMAIL: {
          subject:
            'IN-POOL - Réservé {{user.firstName}} {{user.lastName}} le {{job.date}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour le service suivant :',
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject:
            'IN-POOL - Réservé {{user.firstName}} {{user.lastName}} le {{job.date}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour le service suivant :',
            actionButtonText: 'Aller au service',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_BOOKED_INTERNAL]: {
      [RecipientEnum.USER]: {
        SMS: 'Vous avez été réservé par {{customerName}} : {{departmentName}} \nVers le tableau de bord : {{actionLink}}',
        EMAIL: {
          subject:
            'IN-POOL - Réservé : {{{employment.department.displayName}}}',
          body: {
            introText:
              'Vous avez été réservé par {{customerName}} pour la mission temporaire suivante :',
            outroText: "Vous trouverez en pièce jointe l'entrée du calendrier.",
            actionButtonText: 'Vers le tableau de bord',
          },
        },
        PUSH: {
          title: 'IN-POOL - Réservé : {{employment.department.displayName}}',
          body: 'Vous avez été réservé par {{customerName}} : {{employment.department.displayName}} pour {{formattedDate}}',
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Réservé {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour la mission suivante :',
            actionButtonText: 'Aller à la mission',
          },
        },
        PUSH: {
          title: 'IN-POOL - Réservé {{user.firstName}} {{user.lastName}}',
          body: 'Une personne de {{customerName}} a été réservée pour la mission suivante : {{employment.department.displayName}} pour {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Réservé {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour la mission suivante :',
            actionButtonText: 'Aller à la mission',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Réservé {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour la mission suivante :',
            actionButtonText: 'Aller à la mission',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Réservé {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour la mission suivante :',
            actionButtonText: 'Aller à la mission',
          },
        },
      },
      [RecipientEnum.SHARED_POOL_OWNER]: {
        EMAIL: {
          subject: 'IN-POOL - Réservé {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour la mission suivante :',
            actionButtonText: 'Aller à la mission',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Réservé {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour la mission suivante :',
            actionButtonText: 'Aller à la mission',
          },
        },
      },
    },
    [NotificationEnum.BOOKED_EXTERNAL]: {
      [RecipientEnum.EXTERNAL_USER]: {
        EMAIL: {
          subject: 'IN-POOL - Réservé: {{{job.department.displayName}}}',
          body: {
            introText:
              'Vous avez été réservé par {{customerName}} pour le service suivant :',
            outroText:
              'Pour la saisie des heures, vous recevrez automatiquement un email avec un lien avant le début du service, avec lequel vous pouvez saisir vos heures numériquement.',
          },
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Réservé {{user.firstName}} {{user.lastName}} le {{job.date}} à {{job.department.displayName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour le service suivant :',
            actionButtonText: 'Aller au service',
          },
        },
        PUSH: {
          title:
            'IN-POOL - Réservé {{user.firstName}} {{user.lastName}} le {{job.date}} à {{job.department.displayName}}',
          body: 'Une personne de {{customerName}} a été réservée pour le service suivant : {{job.department.displayName}} le {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Réservé {{user.firstName}} {{user.lastName}} le {{job.date}} à {{job.department.displayName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour le service suivant :',
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject:
            'IN-POOL - Réservé {{user.firstName}} {{user.lastName}} le {{job.date}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour le service suivant :',
            actionButtonText: 'Aller au service',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_BOOKED_EXTERNAL]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Réservé {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour la mission suivante :',
            actionButtonText: 'Aller à la mission',
          },
        },
        PUSH: {
          title: 'IN-POOL - Réservé {{user.firstName}} {{user.lastName}}',
          body: 'Une personne de {{customerName}} a été réservée pour la mission suivante : {{employment.department.displayName}} pour {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Réservé {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour la mission suivante :',
            actionButtonText: 'Aller à la mission',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Réservé {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Une personne de {{customerName}} a été réservée pour la mission suivante :',
            actionButtonText: 'Aller à la mission',
          },
        },
      },
    },
    [NotificationEnum.DECLINED]: {
      [RecipientEnum.USER]: {
        SMS: 'Un service a déjà été pourvu :\n' + '{{departmentName}}',
        EMAIL: {
          subject: 'IN-POOL - Refus pour {{{job.department.displayName}}}',
          body: {
            introText: 'Le service suivant a déjà été pourvu :',
          },
        },
        PUSH: {
          title: 'IN-POOL - Refus pour {{job.department.displayName}}',
          body: 'Le service suivant a déjà été pourvu : {{job.department.displayName}} le {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Refus {{user.firstName}} {{user.lastName}}',
          body: {
            introText: 'Une personne a été refusée pour le service suivant :',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Refus {{user.firstName}} {{user.lastName}}',
          body: {
            introText: 'Une personne a été refusée pour le service suivant :',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Refus {{user.firstName}} {{user.lastName}}',
          body: {
            introText: 'Une personne a été refusée pour le service suivant :',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Refus {{user.firstName}} {{user.lastName}}',
          body: {
            introText: 'Une personne a été refusée pour le service suivant :',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_INVITEE_DECLINED]: {
      [RecipientEnum.USER]: {
        SMS:
          'Une mission temporaire a déjà été pourvue :\n' +
          '{{departmentName}}',
        EMAIL: {
          subject:
            'IN-POOL - Refus pour {{{employment.department.displayName}}}',
          body: {
            introText: 'La mission temporaire suivante a déjà été pourvue : ',
          },
        },
        PUSH: {
          title: 'IN-POOL - Refus pour {{employment.department.displayName}}',
          body: 'La mission temporaire suivante a déjà été pourvue : {{employment.department.displayName}} pour {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Refus {{user.firstName}} {{user.lastName}}',
          body: {
            introText: 'Une personne a été refusée pour la mission suivante :',
          },
        },
      },
    },
    [NotificationEnum.ENROLL_POOLER_ACCOUNT]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Bienvenue dans le pool {{{customerName}}}',
          body: {
            introText: 'Nous sommes heureux de vous accueillir sur In-pool.',
            actionButtonPreText:
              'Veuillez activer votre compte en définissant votre mot de passe via le lien suivant :',
            actionButtonText: 'Activer le compte',
            actionButtonPostText: 'Ce lien est valide une seule fois.',
            secondaryActionPreText:
              "À l'avenir, vous pouvez vous connecter avec votre adresse e-mail et le mot de passe choisi. Veuillez utiliser ce lien",
            secondaryActionText: 'Connexion',
          },
        },
      },
    },
    [NotificationEnum.ENROLL_DISPO_ACCOUNT]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Bienvenue',
          body: {
            introText: 'Nous sommes heureux de vous accueillir sur In-pool.',
            actionButtonPreText:
              'Veuillez activer votre compte en définissant votre mot de passe via le lien suivant :',
            actionButtonText: 'Activer le compte',
            actionButtonPostText: 'Ce lien est valide une seule fois.',
            secondaryActionPreText:
              "À l'avenir, vous pouvez vous connecter avec votre adresse e-mail et le mot de passe choisi. Veuillez utiliser ce lien",
            secondaryActionText: 'Connexion',
          },
        },
      },
    },
    [NotificationEnum.ENROLL_DEMO_ACCOUNT]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'Inpool Demo - Définir le mot de passe',
          body: {
            introText:
              'Bienvenue dans la démo inpool ! Votre environnement de démonstration est prêt.',
            actionButtonPreText:
              'Pour commencer à explorer la démo, veuillez définir votre mot de passe avec le lien suivant : ',
            actionButtonText: 'Définir le mot de passe',
            actionButtonPostText:
              "Ce lien n'est valide qu'une seule fois. Après avoir défini votre mot de passe, vous pourrez explorer entièrement la démo.",
            secondaryActionPreText:
              'Après avoir défini votre mot de passe, vous pouvez vous connecter à tout moment avec votre adresse e-mail. Utilisez ce lien',
            secondaryActionText: 'Vers la démo',
          },
        },
      },
    },
    [NotificationEnum.DEMO_WELCOME]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'Bienvenue à la démo',
          body: {
            introText: 'Bienvenue à la démo !',
            actionButtonPreText:
              "Vous pouvez vous connecter à l'avenir via le lien suivant :",
            actionButtonText: 'Vers la démo',
            actionButtonPostText: '',
          },
        },
      },
    },
    [NotificationEnum.ENROLLMENT_COMPLETED_POOLER]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de collaboration acceptée',
          body: {
            introText: `Un {{userRole}} a accepté votre demande de collaboration et s'est connecté pour la première fois.`,
          },
        },
      },
    },
    [NotificationEnum.ENROLLMENT_COMPLETED_DISPO]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de collaboration acceptée',
          body: {
            introText: `Un {{userRole}} a accepté votre demande de collaboration et s'est connecté pour la première fois.`,
          },
        },
      },
    },
    [NotificationEnum.ENROLL_PHONE]: {
      [RecipientEnum.USER]: {
        SMS: "Pour recevoir des demandes par SMS à l'avenir, vous devez confirmer votre numéro avec le lien suivant :\n{{actionLink}}",
      },
    },
    [NotificationEnum.AUTO_ENROLL_ACCOUNT]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Bienvenue',
          body: {
            introText: 'Nous sommes heureux de vous accueillir sur In-pool.',
            actionButtonText: 'Connexion',
            actionButtonPreText:
              "Vous pouvez vous connecter avec votre identifiant Windows ou Microsoft existant à l'adresse suivante :",
            outroText:
              'Les étapes suivantes sont nécessaires :<ul><li> Saisissez votre adresse e-mail. </li><li> Vous serez automatiquement redirigé vers la page de connexion de votre entreprise. Connectez-vous là avec votre identifiant existant. </li><li> Vous serez automatiquement connecté à In-pool</li></ul>',
          },
        },
      },
    },
    [NotificationEnum.EXTERNAL_API_REQUEST_FAILED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Erreur de requête API',
          body: {
            introText:
              "Une erreur est survenue lors d'une requête API, voici les détails de la requête :",
          },
        },
      },
    },
    [NotificationEnum.INVITEE_CANCELED]: {
      [RecipientEnum.USER]: {
        SMS: 'Un service a été annulé : {{departmentName}}',
        EMAIL: {
          subject: 'IN-POOL - Annulation : {{{job.department.displayName}}}',
          body: {
            introText: 'Le service suivant a été annulé :',
          },
        },
        PUSH: {
          title: 'IN-POOL - Annulation : {{job.department.displayName}}',
          body: 'Service annulé : {{job.department.displayName}} le {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              "L'employé suivant de {{customerName}} a été annulé pour le service :",
            actionButtonText: 'Aller au service',
          },
        },
        PUSH: {
          title: 'IN-POOL - Annulation {{user.firstName}} {{user.lastName}}',
          body: `L'employé suivant de {{customerName}} a été annulé pour le service : {{job.department.displayName}} le {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}`,
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              "L'employé suivant de {{customerName}} a été annulé pour le service :",
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation {{user.firstName}} {{user.lastName}}',
          body: {
            introText: "L'employé suivant a été annulé pour le service :",
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation {{user.firstName}} {{user.lastName}}',
          body: {
            introText: "L'employé suivant a été annulé pour le service :",
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation {{user.firstName}} {{user.lastName}}',
          body: {
            introText: "L'employé suivant a été annulé pour le service :",
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.SHARED_POOL_OWNER]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation {{user.firstName}} {{user.lastName}}',
          body: {
            introText: "L'employé suivant a été annulé pour le service :",
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.ORGANISATION]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              "L'employé suivant de {{customerName}} a été annulé pour le service :",
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              "L'employé suivant de {{customerName}} a été annulé pour le service :",
            actionButtonText: 'Aller au service',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_INVITEE_CANCELED]: {
      [RecipientEnum.USER]: {
        SMS: 'Une mission temporaire a été annulée : {{departmentName}}',
        EMAIL: {
          subject:
            'IN-POOL - Annulation : {{{employment.department.displayName}}}',
          body: {
            introText: 'La mission temporaire suivante a été annulée :',
          },
        },
        PUSH: {
          title: 'IN-POOL - Annulation : {{employment.department.displayName}}',
          body: 'Mission temporaire annulée : {{employment.department.displayName}} pour {{formattedDate}}',
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              "L'employé suivant de {{customerName}} a été annulé pour la mission :",
          },
        },
        PUSH: {
          title: 'IN-POOL - Annulation {{user.firstName}} {{user.lastName}}',
          body: "L'employé suivant de {{customerName}} a été annulé pour la mission : {{employment.department.displayName}} pour {{formattedDate}}",
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              "L'employé suivant de {{customerName}} a été annulé pour la mission :",
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation {{user.firstName}} {{user.lastName}}',
          body: {
            introText: "L'employé suivant a été annulé pour la mission :",
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation {{user.firstName}} {{user.lastName}}',
          body: {
            introText: "L'employé suivant a été annulé pour la mission :",
          },
        },
      },
      [RecipientEnum.SHARED_POOL_OWNER]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation {{user.firstName}} {{user.lastName}}',
          body: {
            introText: "L'employé suivant a été annulé pour la mission :",
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              "L'employé suivant de {{customerName}} a été annulé pour la mission :",
          },
        },
      },
    },
    [NotificationEnum.INVITEE_REPLACED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Remplacement pour {{user.firstName}} {{user.lastName}}',
          body: {
            introText: "L'employé suivant a été remplacé sur ce service :",
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Remplacement pour {{user.firstName}} {{user.lastName}}',
          body: {
            introText: "L'employé suivant a été remplacé sur ce service :",
            actionButtonText: 'Aller au service',
          },
        },
      },
    },
    [NotificationEnum.INVITE]: {
      [RecipientEnum.USER]: {
        SMS: 'Demande de service de {{customerName}} : {{departmentName}} \nVers le tableau de bord : {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Demande : {{{job.department.displayName}}}',
          body: {
            introText:
              'Vous avez reçu une demande de service de {{customerName}} pour le service suivant :',
            actionButtonText: 'Vers le tableau de bord',
          },
        },
        PUSH: {
          title: 'IN-POOL - Demande : {{job.department.displayName}}',
          body: 'Demande de service de {{customerName}} : {{job.department.displayName}} le {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_INVITE]: {
      [RecipientEnum.USER]: {
        SMS: 'Mission temporaire de {{customerName}} : {{departmentName}} \nVers le tableau de bord : {{actionLink}}',
        EMAIL: {
          subject:
            'IN-POOL - Demande : {{{employment.department.displayName}}}',
          body: {
            introText:
              'Vous avez reçu une demande de mission temporaire de {{customerName}} pour la mission suivante :',
            actionButtonText: 'Vers le tableau de bord',
          },
        },
        PUSH: {
          title: 'IN-POOL - Demande : {{employment.department.displayName}}',
          body: 'Mission temporaire de {{customerName}} : {{employment.department.displayName}} pour {{formattedDate}}',
        },
      },
    },
    [NotificationEnum.JOB_CANCELED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation : {{{job.department.displayName}}}',
          body: {
            introText: 'Le service suivant a été annulé :',
            actionButtonText: 'Aller au service',
          },
        },
        PUSH: {
          title: 'IN-POOL - Annulation : {{{job.department.displayName}}}',
          body: 'Le service suivant a été annulé : {{job.department.displayName}} le {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation : {{{job.department.displayName}}}',
          body: {
            introText: 'Le service suivant a été annulé :',
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation : {{{job.department.displayName}}}',
          body: {
            introText: 'Le service suivant a été annulé :',
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation : {{{job.department.displayName}}}',
          body: {
            introText: 'Le service suivant a été annulé :',
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation : {{{job.department.displayName}}}',
          body: {
            introText: 'Le service suivant a été annulé :',
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Annulation : {{{job.department.displayName}}}',
          body: {
            introText: 'Le service suivant a été annulé :',
            actionButtonText: 'Aller au service',
          },
        },
      },
    },
    [NotificationEnum.JOB_DECLINED]: {
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Décliné : {{{job.department.displayName}}}',
          body: {
            introText: 'Le service suivant a été décliné :',
            actionButtonText: 'Aller au service',
          },
        },
      },
    },
    [NotificationEnum.JOB_CLOSED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Service terminé : {{{job.department.displayName}}}',
          body: {
            introText: 'Le service suivant a été terminé :',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Service terminé : {{{job.department.displayName}}}',
          body: {
            introText: 'Le service suivant a été terminé :',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Service terminé : {{{job.department.displayName}}}',
          body: {
            introText: 'Le service suivant a été terminé :',
          },
        },
      },
    },
    [NotificationEnum.JOB_REOPENED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Service rouvert : {{{job.department.displayName}}}',
          body: {
            introText: 'Le service suivant a été rouvert :',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject:
            'IN-POOL - Service rouvert : {{{job.department.displayName}}}',
          body: {
            introText: 'Le service suivant a été rouvert :',
          },
        },
      },
    },
    [NotificationEnum.JOB_REOPENED_INVITE]: {
      [RecipientEnum.USER]: {
        SMS: 'Service rouvert – demande de {{customerName}} : {{departmentName}} \nVers le tableau de bord : {{actionLink}}',
        EMAIL: {
          subject:
            'IN-POOL - Demande (rouverte) : {{{job.department.displayName}}}',
          body: {
            introText:
              'Le service suivant a été rouvert. Vous avez à nouveau reçu une demande de service de {{customerName}} pour le service suivant :',
            actionButtonText: 'Vers le tableau de bord',
          },
        },
        PUSH: {
          title:
            'IN-POOL - Demande (rouverte) : {{job.department.displayName}}',
          body: 'Service rouvert – demande de {{customerName}} : {{job.department.displayName}} le {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
    },
    [NotificationEnum.JOB_REOPENED_TRANSFER]: {
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: '{{{customerName}}} - Transfert de service (rouvert)',
          body: {
            introText:
              'Le service suivant a été rouvert. {{customerName}} vous transmet à nouveau le service suivant par e-mail :',
            actionButtonText: 'Aller au service',
          },
        },
        PUSH: {
          title: '{{{customerName}}} - Transfert de service (rouvert)',
          body: '{{customerName}} vous transmet à nouveau le service suivant (rouvert)',
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'Transfert de service (rouvert) : {{#job}}{{#department}}{{{displayName}}}{{/department}} le {{date}}{{#shifts}} / {{from}} - {{to}} {{/shifts}}{{/job}}',
          body: {
            introText:
              'Le service suivant a été rouvert. {{customerName}} vous transmet à nouveau le service suivant par e-mail :',
            bookingButtonText: 'Vers la demande',
            submitButtonText: 'Vers la demande',
            bookingButtonMessage:
              'Pour réserver un employé potentiel ou refuser la demande, utilisez le lien suivant :',
            submitButtonMessage:
              'Pour soumettre un employé potentiel ou refuser la demande, utilisez le lien suivant :',
          },
        },
      },
    },
    [NotificationEnum.JOB_MISSED]: {
      [RecipientEnum.OTHER_TRANSFER_EDITORS]: {
        EMAIL: {
          subject:
            'IN-POOL - Pourvu ailleurs {{{job.department.displayName}}} le {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
          body: {
            introText: 'Le service suivant a été pourvu ailleurs :',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Pourvu ailleurs {{{job.department.displayName}}} le {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
          body: {
            introText: 'Le service suivant a été pourvu ailleurs :',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Pourvu ailleurs {{{job.department.displayName}}} le {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
          body: {
            introText: 'Le service suivant a été pourvu ailleurs :',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_CANCELED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Annulation : {{{employment.department.displayName}}}',
          body: {
            introText: 'La mission temporaire suivante a été annulée :',
            actionButtonText: 'Aller à la mission',
          },
        },
        PUSH: {
          title:
            'IN-POOL - Annulation : {{{employment.department.displayName}}}',
          body: 'La mission temporaire suivante a été annulée : {{employment.department.displayName}} pour {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Annulation : {{{employment.department.displayName}}}',
          body: {
            introText: 'La mission temporaire suivante a été annulée :',
            actionButtonText: 'Aller à la mission',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject:
            'IN-POOL - Annulation : {{{employment.department.displayName}}}',
          body: {
            introText: 'La mission temporaire suivante a été annulée :',
            actionButtonText: 'Aller à la mission',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Annulation : {{{employment.department.displayName}}}',
          body: {
            introText: 'La mission temporaire suivante a été annulée :',
            actionButtonText: 'Aller à la mission',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Annulation : {{{employment.department.displayName}}}',
          body: {
            introText: 'La mission temporaire suivante a été annulée :',
            actionButtonText: 'Aller à la mission',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_CLOSED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Mission terminée : {{{employment.department.displayName}}}',
          body: {
            introText: 'La mission temporaire suivante a été terminée :',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Mission terminée : {{{employment.department.displayName}}}',
          body: {
            introText: 'La mission temporaire suivante a été terminée :',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Mission terminée : {{{employment.department.displayName}}}',
          body: {
            introText: 'La mission temporaire suivante a été terminée :',
          },
        },
      },
      [RecipientEnum.OTHER_TRANSFER_EDITORS]: {
        EMAIL: {
          subject:
            'IN-POOL - Pourvu ailleurs {{{employment.department.displayName}}} pour {{formattedDate}}',
          body: {
            introText:
              'La mission temporaire suivante a été pourvue ailleurs :',
          },
        },
      },
    },
    [NotificationEnum.NEW_ACCOUNT_PHONE_TOKEN]: {
      [RecipientEnum.USER]: {
        SMS: 'IN-POOL - Votre code de confirmation :\n{{secret}}',
      },
    },
    [NotificationEnum.EMAIL_OPT_IN]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Adresse e-mail modifiée',
          body: {
            actionButtonPreText:
              'Vous avez modifié votre adresse e-mail. <br />Veuillez confirmer cette modification avec le lien suivant :',
            actionButtonText: 'Confirmer',
          },
        },
      },
    },
    [NotificationEnum.PHONE_OPT_IN]: {
      [RecipientEnum.USER]: {
        SMS: 'Vous avez modifié votre numéro. Veuillez confirmer cette modification avec le lien suivant :\n{{actionLink}}',
      },
    },
    [NotificationEnum.ORGANISATION_REQUEST]: {
      [RecipientEnum.USER]: {
        SMS:
          'Nouveau lieu de mission de {{customerName}}.\n' +
          'Veuillez accepter ou refuser : {{actionLink}}',
        EMAIL: {
          subject: 'Offre pour un nouveau lieu de mission',
          body: {
            actionButtonPreText: `{{customerName}} vous propose des missions dans un nouveau lieu. <br />Vous pouvez accepter ou refuser notre offre sur votre tableau de bord.`,
            actionButtonText: 'Vers le tableau de bord',
          },
        },
        PUSH: {
          title: 'Offre pour un nouveau lieu de mission',
          body: 'Nouveau lieu de mission de {{customerName}}. Veuillez accepter ou refuser.',
        },
      },
    },
    [NotificationEnum.POOL_ACCEPTED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de collaboration acceptée',
          body: {
            introText:
              'Un {{userRole}} a accepté votre demande de collaboration.',
            actionButtonText: "Voir l'employé",
          },
        },
      },
    },
    [NotificationEnum.POOL_DECLINED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de collaboration refusée',
          body: {
            introText:
              'Un {{userRole}} a refusé votre demande de collaboration.',
          },
        },
      },
    },
    [NotificationEnum.POOLER_INVITE_REMINDER]: {
      [RecipientEnum.USER]: {
        SMS: 'Rappel : Invitation chez {{departmentName}} toujours en attente',
        EMAIL: {
          subject: 'Rappel - Invitation chez {{{job.department.displayName}}}',
          body: {
            introText:
              'Votre réponse est toujours en attente pour le service suivant :',
            actionButtonText: 'Vers le tableau de bord',
          },
        },
        PUSH: {
          title: 'Rappel - Invitation chez {{job.department.displayName}}',
          body: 'Invitation chez {{job.department.displayName}} du {{job.date}} toujours en attente',
        },
      },
    },
    [NotificationEnum.POOLER_JOB_REMINDER]: {
      [RecipientEnum.USER]: {
        SMS: 'Rappel : Mission chez {{departmentName}} le {{jobDate}} commence à {{jobStartTime}} heures',
        EMAIL: {
          subject: 'Rappel - Mission chez {{{job.department.displayName}}}',
          body: {
            introText: 'Le service suivant va bientôt commencer :',
          },
        },
        PUSH: {
          title: 'Rappel - Mission chez {{job.department.displayName}}',
          body: 'Mission chez {{job.department.displayName}} du {{job.date}} commence à {{jobStartTime}} heures',
        },
      },
    },
    [NotificationEnum.POOLER_TRANSFERRED]: {
      [RecipientEnum.USER]: {
        SMS: 'Vous avez été transféré pour le service : vers {{departmentName}} \nVers le tableau de bord : {{actionLink}}',
        EMAIL: {
          subject:
            'IN-POOL - Transféré : vers {{{job.department.displayName}}}',
          body: {
            introText: 'Vous avez été transféré pour le service suivant :',
            from: 'De',
            to: 'À',
          },
        },
        PUSH: {
          title: 'IN-POOL - Transféré : vers {{job.department.displayName}}',
          body: 'Vous avez été transféré pour le service le {{job.date}} vers {{job.department.displayName}} le {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
    },
    [NotificationEnum.POOL_REMOVED]: {
      [RecipientEnum.USER]: {
        SMS: 'Nous confirmons par la présente que vous avez été supprimé de notre pool et que vos données ont été supprimées en conséquence.',
        EMAIL: {
          subject: 'IN-POOL - Désinscription : pool de {{{customerName}}}',
          body: {
            introText:
              'Nous confirmons par la présente que vous avez été désinscrit de notre pool et que vos données ont été supprimées en conséquence.',
            outroText: "Pour toute question, n'hésitez pas à nous contacter.",
          },
        },
        PUSH: {
          title: 'IN-POOL - Désinscription : pool de {{customerName}}',
          body: 'Nous confirmons par la présente que vous avez été désinscrit de notre pool et que vos données ont été supprimées en conséquence.',
        },
      },
    },
    [NotificationEnum.POOL_REQUEST]: {
      [RecipientEnum.USER]: {
        SMS:
          '{{customerName}} souhaite vous ajouter à son pool.\n' +
          'Accepter ou refuser la demande : {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Demande de pool',
          body: {
            introText: `{{customerName}} souhaite vous ajouter à son pool.<br />Vous pouvez accepter ou refuser cette demande sur votre tableau de bord.`,
            actionButtonText: 'Vers le tableau de bord',
          },
        },
        PUSH: {
          title: 'IN-POOL - Demande de pool',
          body: '{{customerName}} souhaite vous ajouter à son pool. Accepter ou refuser la demande.',
        },
        SYS: '',
      },
    },
    [NotificationEnum.POSSIBLE_CANDIDATE]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Nouveau candidat potentiel',
          body: {
            introText:
              'Une personne potentielle a été soumise pour le service suivant :',
            textBeforeAction: "Acceptez l'employé souhaité :",
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Nouveau candidat potentiel',
          body: {
            introText:
              'Une personne potentielle a été soumise pour le service suivant :',
            textBeforeAction: "Acceptez l'employé souhaité :",
            actionButtonText: 'Aller au service',
          },
        },
      },
    },
    [NotificationEnum.PROFILE_INFO_CHANGED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Mise à jour des données par un pooler',
          body: {
            introText: '{{userName}} a mis à jour les informations suivantes :',
            changedByEditor:
              'Les informations ont été mises à jour par {{editorName}}.',
            changedByDifferentCustomer:
              'Les informations ont été mises à jour par un autre client.',
          },
          changedInfoKeys: {
            firstName: 'Prénom',
            lastName: 'Nom',
            email: 'E-Mail',
            sex: 'Sexe',
            phone: 'Téléphone',
            notifyEmail: 'Notification E-Mail',
            notifySms: 'Notification SMS',
            shifts: 'Postes',
            jobTypes: 'Types de mission',
          },
        },
      },
    },
    [NotificationEnum.REASK]: {
      [RecipientEnum.USER]: {
        SMS: 'Réponse en attente ceci est un long texte pour tester le raccourcissement abc lorem ipsum abc test test : {{departmentName}}  \nVers le tableau de bord : {{actionLink}}',
        EMAIL: {
          subject:
            'IN-POOL - Réponse en attente : {{{job.department.displayName}}}',
          body: {
            introText:
              'Votre réponse est toujours en attente pour le service suivant :',
            actionButtonText: 'Vers le tableau de bord',
          },
        },
        PUSH: {
          title:
            'IN-POOL - Réponse en attente : {{job.department.displayName}}',
          body: 'Demande de service de {{customerName}} : {{job.department.displayName}} le {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
        SYS: '',
      },
    },
    [NotificationEnum.TRANSFER_DECLINED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Transfert refusé : {{{job.department.displayName}}}',
          body: {
            introText:
              'Le transfert du service suivant par {{customerName}} a été refusé :',
            actionButtonText: 'Aller au service',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Transfert refusé : {{{job.department.displayName}}}',
          body: {
            introText:
              'Le transfert du service suivant par {{customerName}} a été refusé :',
            actionButtonText: 'Aller au service',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_TRANSFER_DECLINED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Transfert refusé : {{{employment.department.displayName}}}',
          body: {
            introText:
              'Le transfert de la mission suivante par {{customerName}} a été refusé :',
            actionButtonText: 'Aller à la mission',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Transfert refusé : {{{employment.department.displayName}}}',
          body: {
            introText:
              'Le transfert de la mission suivante par {{customerName}} a été refusé :',
            actionButtonText: 'Aller à la mission',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_POSSIBLE_CANDIDATE]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Nouveau candidat potentiel',
          body: {
            introText:
              'Une personne potentielle a été soumise pour le mission suivant :',
            textBeforeAction: "Acceptez l'employé souhaité :",
            actionButtonText: 'Aller au mission',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Nouveau candidat potentiel',
          body: {
            introText:
              'Une personne potentielle a été soumise pour le mission suivant :',
            textBeforeAction: "Acceptez l'employé souhaité :",
            actionButtonText: 'Aller au mission',
          },
        },
      },
    },
    [NotificationEnum.TRANSFER_EXTERNAL_API_REQUEST_FAILED]: {
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'Transfert de service : {{#job}}{{#department}}{{{displayName}}}{{/department}} le {{date}}{{#shifts}} / {{from}} - {{to}} {{/shifts}}{{/job}}',
          body: {
            introText: `Une erreur est survenue lors du transfert d'un service via l'API. <br />{{customerName}} vous transmet le service suivant par e-mail :`,
            bookingButtonText: 'Réserver',
            submitButtonText: 'Soumettre',
            bookingButtonMessage:
              'Pour réserver directement un employé, utilisez le lien suivant :',
            submitButtonMessage:
              'Pour soumettre un employé potentiel, utilisez le lien suivant :',
          },
        },
      },
    },
    [NotificationEnum.TRANSFER]: {
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: '{{{customerName}}} - Transfert de service',
          body: {
            introText:
              '{{customerName}} vous transmet le service suivant par e-mail :',
            actionButtonText: 'Aller au service',
          },
        },
        PUSH: {
          title: '{{{customerName}}} - Transfert de service',
          body: '{{customerName}} vous transmet le service suivant',
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'Transfert de service : {{#job}}{{#department}}{{{displayName}}}{{/department}} le {{date}}{{#shifts}} / {{from}} - {{to}} {{/shifts}}{{/job}}',
          body: {
            introText:
              '{{customerName}} vous transmet le service suivant par e-mail :',
            bookingButtonText: 'Vers la demande',
            submitButtonText: 'Vers la demande',
            bookingButtonMessage:
              'Pour réserver un employé potentiel ou refuser la demande, utilisez le lien suivant :',
            submitButtonMessage:
              'Pour soumettre un employé potentiel ou refuser la demande, utilisez le lien suivant :',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_TRANSFER]: {
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: '{{{customerName}}} - Transfert de mission',
          body: {
            introText:
              '{{customerName}} vous transmet la mission suivante par :',
            actionButtonText: 'Aller à la mission',
          },
        },
        PUSH: {
          title: '{{{customerName}}} - Transfert de mission',
          body: '{{customerName}} vous transmet la mission suivant',
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'Transfert de mission : {{#employment}}{{#department}}{{{displayName}}}{{/department}} le {{date}}{{#shifts}} / {{from}} - {{to}} {{/shifts}}{{/employment}}',
          body: {
            introText:
              '{{customerName}} vous transmet la mission suivante par e-mail :',
            submitButtonText: 'Vers la demande',
            submitButtonMessage:
              'Pour soumettre un employé potentiel ou refuser la demande, utilisez le lien suivant :',
          },
        },
      },
    },
    [NotificationEnum.AVAILABILITY_UPDATES_REPORT]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'Mises à jour des disponibilités',
          body: {
            introText:
              'Vous trouverez en pièce jointe les disponibilités des employés qui ont changé depuis le dernier e-mail.',
          },
        },
      },
    },
    [NotificationEnum.TWO_FACTOR_AUTH_PHONE]: {
      [RecipientEnum.USER]: {
        SMS: 'Votre code est : {{secret}}',
      },
    },
    [NotificationEnum.TWO_FACTOR_AUTH_EMAIL]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Authentification à deux facteurs',
          body: {
            introText:
              "Votre code pour l'authentification à deux facteurs est : {{secret}}",
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_INFORMATION_CHANGED]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject:
            "IN-POOL - Les informations relatives à l'emploi ont été modifiées",
          body: {
            introText: 'Un emploi temporaire a modifié les données suivantes:',
            actionButtonText: "Vers l'emploi",
          },
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            "IN-POOL - Les informations relatives à l'emploi ont été modifiées",
          body: {
            introText: 'Un emploi temporaire a modifié les données suivantes:',
            actionButtonText: "Vers l'emploi",
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            "IN-POOL - Les informations relatives à l'emploi ont été modifiées",
          body: {
            introText: 'Un emploi temporaire a modifié les données suivantes:',
            actionButtonText: "Vers l'emploi",
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject:
            "IN-POOL - Les informations relatives à l'emploi ont été modifiées",
          body: {
            introText: 'Un emploi temporaire a modifié les données suivantes:',
            actionButtonText: "Vers l'emploi",
          },
        },
      },
    },
    [NotificationEnum.AUTO_BOOKED_ON_TRANSFER]: {
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Réservé {{user.firstName}} {{user.lastName}} le {{job.date}} à {{job.department.displayName}}',
          body: {
            introText:
              'Une personne a été automatiquement réservée pour le service suivant lors du transfert:',
            actionButtonText: 'Vers le service',
          },
        },
      },
    },
    [NotificationEnum.AUTO_POSSIBLE_CANDIDATE_ON_TRANSFER]: {
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Candidat possible {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Une personne a été automatiquement soumise comme candidat possible pour le service suivant lors du transfert:',
            actionButtonText: 'Vers le service',
          },
        },
      },
    },
    [NotificationEnum.JOB_REQUESTED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de service',
          body: {
            introText:
              "Une nouvelle demande de service a été créée, veuillez vérifier la demande et l'accepter ou la refuser.",
            actionButtonText: 'Voir les demandes',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de service',
          body: {
            introText:
              "Une nouvelle demande de service a été créée, veuillez vérifier la demande et l'accepter ou la refuser.",
            actionButtonText: 'Voir les demandes',
          },
        },
      },
    },
    [NotificationEnum.JOB_RETRACTION_REQUESTED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de retrait du service',
          body: {
            introText:
              "Une demande de retrait du service a été créée, veuillez vérifier la demande et l'accepter ou la refuser.",
            actionButtonText: 'Voir les demandes',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de retrait du service',
          body: {
            introText:
              "Une demande de retrait du service a été créée, veuillez vérifier la demande et l'accepter ou la refuser.",
            actionButtonText: 'Voir les demandes',
          },
        },
      },
    },
    [NotificationEnum.JOB_REQUEST_ACCEPTED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de service acceptée',
          body: {
            introText:
              'La demande de service suivante a été acceptée par {{activeUserFirstName}} {{activeUserLastName}} :',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de service acceptée',
          body: {
            introText:
              'La demande de service suivante a été acceptée par {{activeUserFirstName}} {{activeUserLastName}} :',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de service acceptée',
          body: {
            introText:
              'La demande de service suivante a été acceptée par {{activeUserFirstName}} {{activeUserLastName}} :',
          },
        },
      },
    },
    [NotificationEnum.JOB_REQUEST_DECLINED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de service refusée',
          body: {
            introText:
              'La demande de service suivante a été refusée par {{activeUserFirstName}} {{activeUserLastName}} :',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de service refusée',
          body: {
            introText:
              'La demande de service suivante a été refusée par {{activeUserFirstName}} {{activeUserLastName}} :',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de service refusée',
          body: {
            introText:
              'La demande de service suivante a été refusée par {{activeUserFirstName}} {{activeUserLastName}} :',
          },
        },
      },
    },
    [NotificationEnum.JOB_RETRACTION_REQUEST_ACCEPTED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de retrait du service acceptée',
          body: {
            introText:
              'La demande de retrait du service a été acceptée par {{activeUserFirstName}} {{activeUserLastName}} :',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de retrait du service acceptée',
          body: {
            introText:
              'La demande de retrait du service a été acceptée par {{activeUserFirstName}} {{activeUserLastName}} :',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de retrait du service acceptée',
          body: {
            introText:
              'La demande de retrait du service a été acceptée par {{activeUserFirstName}} {{activeUserLastName}} :',
          },
        },
      },
    },
    [NotificationEnum.JOB_RETRACTION_REQUEST_DECLINED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de retrait du service refusée',
          body: {
            introText:
              'La demande de retrait du service a été refusée par {{activeUserFirstName}} {{activeUserLastName}} :',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de retrait du service refusée',
          body: {
            introText:
              'La demande de retrait du service a été refusée par {{activeUserFirstName}} {{activeUserLastName}} :',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Demande de retrait du service refusée',
          body: {
            introText:
              'La demande de retrait du service a été refusée par {{activeUserFirstName}} {{activeUserLastName}} :',
          },
        },
      },
    },
    [NotificationEnum.NEW_JOB_REQUEST_NEEDS_APPROVAL]: {
      [RecipientEnum.CUSTOMER]: {
        SMS: 'Une nouvelle demande de service a été soumise. Veuillez vérifier la demande :\n{{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Nouvelle demande de service',
          body: {
            introText:
              'Une nouvelle demande de service a été soumise pour le service suivant :',
            textBeforeAction:
              'Vérifiez la demande et acceptez-la ou refusez-la :',
            actionButtonText: 'Aller aux demandes en attente',
          },
        },
      },
    },
    [NotificationEnum.UNMAPPED_PERIGON_JOBS]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Services avec attribution Perigon manquante',
          body: {
            introText:
              'Il y a {{unmappedJobsCount}} services avec une attribution Perigon manquante.',
            unmappedPerigonJobsMessage:
              'Veuillez vérifier les attributions Perigon des services et les corriger.',
            actionButtonText: 'Aller aux services',
          },
        },
      },
    },
    [NotificationEnum.DISPO_REMOVED_FROM_POOL]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Disposant retiré',
          body: {
            introText: 'Un disposant a été retiré du pool.',
          },
        },
      },
    },
    [NotificationEnum.POOLER_REMOVED_FROM_POOL]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Pooler retiré',
          body: {
            introText: 'Un pooler a été retiré du pool.',
          },
        },
      },
    },
    [NotificationEnum.REQUESTER_REMOVED_FROM_POOL]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Demandeur retiré',
          body: {
            introText: 'Un demandeur a été retiré du pool.',
          },
        },
      },
    },
  },
};
